import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconEpisode$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconEpisode extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0913a2953758b3b361ef98dd0ea7111ee29d580d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8de64bc3d4964fcb9aa09ecc2854661d607890a0', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '699e5843dd5b45795366242fbc98452dea075802', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.92 2.5a.5.5 0 0 1 .5-.5h9.08a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-.5.5H6.42a.5.5 0 0 1-.5-.5zM4.01 6a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5zM2 9.5a.5.5 0 0 1 .5-.5h17a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5zm16.5 1v8h-15v-8zM9 16.84v-4.68a.3.3 0 0 1 .45-.26l4.41 2.47a.3.3 0 0 1 0 .53l-4.43 2.21a.3.3 0 0 1-.43-.27", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-episode", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-episode"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-episode":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconEpisode$1);
            }
            break;
    } });
}

const CosmosIconEpisode = CosmosIconEpisode$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconEpisode, defineCustomElement };
